import { all } from "redux-saga/effects";
import { accountDetailsWatcher, accountUpdateWatcher, forgotPasswordWatcher, loginWorkerWatcher, registerWatcher, resetPasswordWatcher, uploadImageWatcher } from "./authSaga";
import { createProductWatcher, deleteProductWatcher, editProductWatcher, listProductWatcher, productBulkUploadWatcher, viewProductWatcher } from "./productSaga";
import { customersDropdownWatcher, exportReportWatcher, generateBillWatcher, listBillingWatcher, productDropdownWatcher } from "./billingSaga";
import { dashboardMonthlySalesWatcher, dashboardWatcher } from "./dashboardSags";
import { plansListWatcher, razorpayCreateOrderWatcher, razorpayPaymentSuccessWatcher, stripeCheckoutWatcher, stripePaymentSuccessWatcher, subscriptionListWatcher } from "./paymentSaga";

export default function* rootSaga() {
    yield all([
        /**Watcher functions to be added here */
        loginWorkerWatcher(),
        accountDetailsWatcher(),
        accountUpdateWatcher(),
        uploadImageWatcher(),
        registerWatcher(),
        forgotPasswordWatcher(),
        resetPasswordWatcher(),

        dashboardWatcher(),
        dashboardMonthlySalesWatcher(),

        createProductWatcher(),
        editProductWatcher(),
        deleteProductWatcher(),
        listProductWatcher(),
        viewProductWatcher(),
        productBulkUploadWatcher(),

        listBillingWatcher(),
        generateBillWatcher(),
        productDropdownWatcher(),
        exportReportWatcher(),
        customersDropdownWatcher(),

        stripeCheckoutWatcher(),
        plansListWatcher(),
        stripePaymentSuccessWatcher(),
        subscriptionListWatcher(),
        razorpayCreateOrderWatcher(),
        razorpayPaymentSuccessWatcher()
    ]);
}